import {
	COLORS,
	fontFamily,
	RADIUS,
	SHADOWS,
	Text,
	Spacings,
	Devices,
	Sizes
} from '../base/indexV2'

// scaffolded for future — same keys as LightV2, dark values
export const DarkThemeV2 = {
	colors: {
		surface: {
			page:    '#0D1117',
			card:    '#161B22',
			overlay: '#1C2128',
			sunken:  '#0D1117',
		},

		text: {
			primary:   COLORS.neutral[0],
			secondary: COLORS.neutral[300],
			disabled:  COLORS.neutral[400],
			inverse:   COLORS.neutral[900],
			link:      COLORS.blue.muted,
		},

		border: {
			default: '#30363D',
			strong:  '#484F58',
			focus:   COLORS.blue.default,
		},

		brand: {
			primary:  COLORS.blue.default,
			hover:    COLORS.blue.muted,
			subtle:   '#1C2D4A',
			muted:    COLORS.blue.muted,
		},

		status: {
			success: {
				bg:     '#0D2B1E',
				text:   COLORS.green.muted,
				border: COLORS.green.emphasis,
				icon:   COLORS.green.default,
			},
			warning: {
				bg:     '#2B1D09',
				text:   COLORS.yellow.muted,
				border: COLORS.yellow.emphasis,
				icon:   COLORS.yellow.default,
			},
			error: {
				bg:     '#2B0D12',
				text:   COLORS.red.muted,
				border: COLORS.red.emphasis,
				icon:   COLORS.red.default,
			},
			info: {
				bg:     '#0D1B2B',
				text:   COLORS.blue.muted,
				border: COLORS.blue.emphasis,
				icon:   COLORS.blue.default,
			},
			neutral: {
				bg:     '#1C2128',
				text:   COLORS.neutral[300],
				border: '#30363D',
				icon:   COLORS.neutral[400],
			},
		},
	},

	fontFamily,
	radius: RADIUS,
	shadows: SHADOWS,
	Text,
	Spacings,
	Devices,
	Sizes,
}
